angular.module('elfium').filter('reportPhasesByTaskType', ['TASK_TYPES', 'REPORT_PHASE', function (TASK_TYPES, REPORT_PHASE) {
    return function (taskType) {
    	var reportPhasesByTaskType = {};
        reportPhasesByTaskType[TASK_TYPES.KOTEVRENI] = [REPORT_PHASE.OTEVRENI_PRIPADU, REPORT_PHASE.DOMLUV_PRVNI_SCHUZKA];
        reportPhasesByTaskType[TASK_TYPES.POTREBA] = [REPORT_PHASE.PROBEHLA_PRVNI_SCHUZKA, REPORT_PHASE.CHCI_NABIDKU];
        reportPhasesByTaskType[TASK_TYPES.NABIDKA] = [REPORT_PHASE.PRVNI_PREDANI_NABIDKY, REPORT_PHASE.ROZHODNUTI_O_NABIDCE];
        reportPhasesByTaskType[TASK_TYPES.KUZAVRENI] = [REPORT_PHASE.ZADANI_DO_PT];
        return reportPhasesByTaskType[taskType];
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportPhasesByTaskTypeFilter.ts